export const SHAPE_TYPES = {
  IMAGE_ELEMENT: "IMAGE_ELEMENT",
  BACKGROUND_IMAGE: "BACKGROUND_IMAGE",
  MERGE_FIELD: "MERGE_FIELD",
  ICON_ELEMENT: "ICON_ELEMENT",
  SHAPE_ELEMENT: "SHAPE_ELEMENT",
  TEXT_ELEMENT: "TEXT_ELEMENT",
  TEXT_TEMPLATE: "TEXT_TEMPLATE",
  TEMPLATE: "TEMPLATE",
};

export const SIDEBAR_ITEMS = [
  {
    name: "Template",
    key: SHAPE_TYPES.TEMPLATE,
    icon: "",
  },
  {
    name: "Image",
    key: SHAPE_TYPES.IMAGE_ELEMENT,
    icon: "",
  },
  {
    name: "Background",
    key: SHAPE_TYPES.BACKGROUND_IMAGE,
    icon: "",
  },
  {
    name: "Text",
    key: SHAPE_TYPES.TEXT_ELEMENT,
    icon: "",
  },
  {
    name: "Merge Fields",
    key: SHAPE_TYPES.MERGE_FIELD,
    icon: "",
  },
  {
    name: "Icon",
    key: SHAPE_TYPES.ICON_ELEMENT,
    icon: "",
  },
];
